import { createFileRoute } from "@tanstack/react-router";
import { PageHeader } from "@/client/components/page-header";
import { apiQuery } from "@/client/lib/api";
import { ensurePage, pageHead } from "@/client/lib/page";
import { DitadoClient } from "@/client/modules/cirurgias/ditado/ditado-client";
import Loading from "@/client/modules/cirurgias/ditado/loading";

/**
 * MODO DITADO — o profissional dita a descrição cirúrgica de memória e a IA
 * organiza. Gate no servidor: IA clínica + cirurgias + profissional.
 */
export const Route = createFileRoute("/app/cirurgias/ditado")({
  validateSearch: (s: Record<string, unknown>): { cirurgia?: string } => ({
    cirurgia: s.cirurgia as string | undefined,
  }),
  loader: ({ context }) => ensurePage(context.queryClient, apiQuery("cirurgias", "ditadoPage", {})),
  head: () => pageHead("Ditar descrição cirúrgica"),
  pendingComponent: Loading,
  component: DitadoPage,
});

function DitadoPage() {
  const { cirurgia } = Route.useSearch();
  return (
    <div className="mx-auto flex max-w-7xl flex-col gap-6">
      <PageHeader
        title="Ditar descrição cirúrgica"
        description="Dite do jeito que sair — a IA organiza no formato da descrição. Você revisa antes de salvar."
      />
      <DitadoClient cirurgiaIdInicial={cirurgia} />
    </div>
  );
}
